import "regenerator-runtime/runtime.js";
import React from "react";
import ReactDom from "react-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from "./components/App";
import ErrorHandler from "./components/ErrorHandler";
import { Provider } from "react-redux";
import { createStore, compose } from "redux";
import { ToastProvider, ToastConsumer } from 'global-components-library'
import reducer from "./redux/reducers";
import {ClearBrowserCacheBoundary} from "./components/ClearCache";
import "@babel/polyfill";
import { name, version } from "../package.json";
let path = "AgentKolob/version.json";
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store = null;
if (process.env.NODE_ENV === "development") {
  store = createStore(reducer, {}, composeEnhancers());
  path="version.json";
} else {
  store = createStore(reducer);
}
console.log("Project data\nName:", name, "\nVersion:", version);

ReactDom.render(
  <ClearBrowserCacheBoundary filename={path}>
  <Provider store={store}>
    <ErrorHandler>
    <ToastProvider >
      <ToastConsumer>
        {context => <App {...context} />}
      </ToastConsumer>
    </ToastProvider>
    </ErrorHandler>
  </Provider>
  </ClearBrowserCacheBoundary>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js